import React from 'react';
import { Outlet } from 'react-router-dom';

import VideoBlock from '../../components/common/video-block/VideoBlock';

import { ReactComponent as LogoWhite } from '../../resources/logos/atp-logo-white.svg';
import { ReactComponent as LogoLight } from '../../resources/logos/atp-logo-light.svg';
import { ReactComponent as FoxFin } from '../../resources/icons/fox-fin.svg';
import { ReactComponent as HubOfAfricanTrade } from '../../resources/icons/the-hub-of-african-trade.svg';
import { ReactComponent as ProsperAfrica } from '../../resources/icons/prosper-africa.svg';

import './auth-layout.scss';

const AuthLayout = () => {
  return (
    <section className="auth-layout">
      <section className="auth-layout__left">
        <LogoWhite className="auth-layout__logo" />
        <div className="auth-layout__big-text">
          <p>Export.</p>
          <p>Import.</p>
          <p>Finance.</p>
        </div>
        <div className="auth-layout__sub-text">
          <p>
            The online marketplace for <b>vetted</b>
          </p>
          <p>
            <b>buyers and suppliers</b> of bulk goods.
          </p>
        </div>
        <div className="auth-layout__logos">
          <HubOfAfricanTrade />
          <FoxFin />
          <ProsperAfrica />
        </div>
        <div className="auth-layout__bottom-text">
          <p>African Trade Platform is supported by USAID Africa Trade and Investment Program</p>
          <p>and Prosper Africa. All due diligence on traders is done by Foxfin Financial Services.</p>
          <p>Terms and Conditions. Privacy Policy.</p>
        </div>
      </section>
      <section className="auth-layout__middle">
        <VideoBlock
          label="Developing AGOA & GSP utilisation strategies for African countries via SMEs participation: Webinar 6"
          id="-YABBUSnK-M?si=xDtFyZSWBsN7e_wB"
        />
        <VideoBlock
          label="AGOA Webinar 5: Textile and Apparel export requirements for the U.S."
          id="v5BMjKJdL4k?si=eqld9gkSf5sJWcW8"
        />
        <VideoBlock
          label="AGOA WEBINAR 4: Exporting agricultural produce from Africa to the U.S. under AGOA & GSP"
          id="f5aiGbeRAlE?si=eqFbpmI6301ziFeZ"
        />
        <VideoBlock
          label="AGOA WEBINAR 3: Understanding the economic transformational potential AGOA & GSP for Africa: Part 3"
          id="12XVVlHAqDc?si=6MgKMYhHYtY1tBXn"
        />
      </section>
      <section className="auth-layout__right">
        <div className="auth-layout__right__container">
          <LogoLight className="auth-layout__right__logo" />
          <Outlet />
        </div>
      </section>
    </section>
  );
};

export default AuthLayout;
